module.exports = __webpack_public_path__ + "static/media/blackClose.828ecf55.png";